import { useScopedSelector } from 'ia-react-core';
import React, { FC } from 'react';
import { UsernameFormPageState } from '../../../../../interfaces/UsernameFormPageState';
import UsernameControlCommon from '../../../../../components/_UsernameControl';

export interface UsernameControlProps { }

const UsernameControl: FC<UsernameControlProps> = () => {
  const isSubmitting: boolean = useScopedSelector((state: UsernameFormPageState) => state.usernameForm?.isSubmitting);

  return (<UsernameControlCommon isSubmitting={isSubmitting} />);
};

export default UsernameControl;
